import AppForm from '../app-components/Form/AppForm';
import moment from 'moment';

var userLanguage = document.documentElement.lang;

Vue.component('maternity-leave', {
    mixins: [AppForm],
    props: {
        'data': {
            type: Array,
        },
        'trans': {
            type: Object,
        },
        'refreshUrl': {
            type: String,
        }
    },
    data: function() {
        return {
            deletingMaternityLeaveId: null,
            mutableMaternityLeaves: this.data
        };
    },
    
    created: function(){
        this.$root.$on('updatematernityleavesgrid', () => {
            this.updateMaternityLeaves();
        });
    },

    methods: {
        addMaternityLeave() {
            this.$modal.show('maternity-leave-form');
        },

        editMaternityLeave(item) {
            this.$modal.show('maternity-leave-form', { maternityLeave: item });
        },

        deleteMaternityLeave: function(url, id) {
            let _this = this;
            this.deletingMaternityLeaveId = id;
            this.$modal.show('dialog', {
                title: _this.trans.delete_form.title,
                text: _this.trans.delete_form.text,
                buttons: [{ title: _this.trans.delete_form.no, handler: function handler(){ _this.$modal.hide('dialog');_this.deletingMaternityLeaveId = null; } }, {
                    title: '<span class="btn-dialog btn-danger">'+_this.trans.delete_form.yes+'<span>',
                    handler: function handler() {
                        _this.$modal.hide('dialog');
                        axios.delete(url).then(function (response) {
                            _this.$notify({ type: 'success', title: _this.trans.delete_form.success_title, text: response.data.message ? response.data.message : _this.trans.delete_form.success_text });

                            _this.updateMaternityLeaves();
                        }, function (error) {
                            _this.$notify({ type: 'error', title: _this.trans.delete_form.error_title, text: error.response.data.message ? error.response.data.message : _this.trans.delete_form.error_text });
                        });
                    }
                }]
            });


        },

        updateMaternityLeaves() {
            let _this = this;
            
            axios.get(this.refreshUrl).then(function (response) {
               _this.mutableMaternityLeaves = response.data;
            }, function (error) {
               _this.$notify({ type: 'error', title: "Error", text: error.response.data.message ? error.response.data.message : "Error during refresh of maternity leaves." });
            });

        },
    },
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY')
    } else {
        return '...';
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/EmployeeMaternityLeave.js